// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__16uYQ","header":"PatientBlock_header__153CI","label":"PatientBlock_label__2f2K3","option":"PatientBlock_option__1OUsI"};